export default __webpack_public_path__ + "static/lefafa_2_2-09cdb5cfb4c250c38b24003b97eb2768.webp";